module.exports = __webpack_public_path__ + "img/south_africa_icc.9d156dee.png";